import React, { useContext } from "react";
import { View, Text, Image } from "react-native";
import { useColorScheme } from "react-native-appearance";
import Icon from "react-native-vector-icons/Ionicons";
import { colors } from "../context/Colors";
import AppContext from "../context";

export default function GameFooter({ g, size }) {
  const theme = useColorScheme() === "dark" ? "dark" : "light";
  const { resolveURL, dict } = useContext(AppContext);
  return (
    <View>
      {/* <Text>{g.state}</Text> */}
      {g.state !== "correct" &&
      g.state !== "failed" &&
      g.maxNumberOfAttempts ? (
        <View
          style={{
            borderWidth: 2,
            borderColor: colors[theme].gamePreamble,
            flexDirection: "row",
            marginTop: 40,
            alignItems: "center",
            borderRadius: 8,
            alignSelf: "flex-start",
            paddingRight: 10,
          }}
        >
          <View
            style={{
              backgroundColor: colors[theme].gamePreamble,
              padding: 8,
              marginRight: 10,
            }}
          >
            <Icon
              name="information-circle-outline"
              size={24}
              color={colors[theme].text}
              style={{ opacity: 0.4 }}
            />
          </View>
          <Text style={{ color: colors[theme].text, opacity: 0.5 }}>
            {g.maxNumberOfAttempts}{" "}
            {g.maxNumberOfAttempts > 1 ? dict.tries_left : dict.try_left}
          </Text>
        </View>
      ) : null}
      {g.state === "correct" ? (
        <View
          style={{
            backgroundColor: "#E4F3E7",
            flexDirection: "row",
            padding: 10,
            borderRadius: 6,
            marginTop: 30,
            alignItems: "center",
          }}
        >
          <View
            style={{
              backgroundColor: "#26C97A",
              width: 32,
              height: 32,
              borderRadius: 18,
              justifyContent: "center",
              alignItems: "center",
              marginRight: 10,
            }}
          >
            <Icon name="md-checkmark-sharp" size={24} color="#FFF" />
          </View>
          <Text style={{ color: "#26C97A", fontSize: 18, fontWeight: "bold" }}>
            {dict.challenge_completed}
          </Text>
        </View>
      ) : null}

      {g.state === "failed" && g.giveAnswerOnFailure ? (
        <>
          <View
            style={{
              backgroundColor: "#F4E3E3",
              flexDirection: "row",
              padding: 10,
              borderRadius: 6,
              marginTop: 30,
              alignItems: "center",
            }}
          >
            <View
              style={{
                backgroundColor: "#DD4D4D",
                width: 32,
                height: 32,
                borderRadius: 18,
                justifyContent: "center",
                alignItems: "center",
                marginRight: 10,
              }}
            >
              <Icon name="md-close-sharp" size={24} color="#FFF" />
            </View>
            <Text
              style={{ color: "#DD4D4D", fontSize: 18, fontWeight: "bold" }}
            >
              {dict.challenge_failed}
            </Text>
          </View>
          {g.challengeType !== "TakePhoto" ? (
            <View style={{ marginTop: 20 }}>
              <Text
                style={{
                  fontSize: 18,
                  fontWeight: "bold",
                  color: colors[theme].text,
                }}
              >
                {dict.correct_answer_was}
              </Text>
              {g.challengeType === "MCQImage" ? (
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                  }}
                >
                  {g.propositions
                    .filter((i) => i.flag)
                    .map((a) => (
                      <View key={a.propositionID}>
                        <Image
                          source={{
                            uri: resolveURL("game", a.imageReference, 300),
                          }}
                          style={{
                            width: size,
                            height: size,
                            borderRadius: 8,
                            marginTop: 10,
                          }}
                          resizeMode={"contain"}
                        />
                        <Text
                          style={{
                            marginTop: 5,
                            fontSize: 16,
                            color: colors[theme].text,
                            opacity: 0.7,
                            textAlign: "center",
                          }}
                        >
                          {a.text}
                        </Text>
                      </View>
                    ))}
                </View>
              ) : (
                <>
                  <Text
                    style={{
                      marginTop: 5,
                      fontSize: 16,
                      color: colors[theme].text,
                      opacity: 0.7,
                    }}
                  >
                    {g.goodAnswer}
                  </Text>
                  {g.challengeType === "FindObject" &&
                  g.aROverlayImageReference ? (
                    <Image
                      source={{
                        uri: resolveURL("game", g.aROverlayImageReference, 300),
                      }}
                      style={{
                        width: 100,
                        height: 100,
                        borderRadius: 8,
                        marginTop: 10,
                      }}
                      resizeMode={"contain"}
                    />
                  ) : null}
                </>
              )}
            </View>
          ) : null}
        </>
      ) : null}
      {(g.state === "failed" || g.state === "correct") &&
        g.answerComplementMessage && (
          <View>
            <Text
              style={{
                fontSize: 19,
                color: colors[theme].text,
                marginBottom: 20,
                fontWeight: "600",
                marginTop: 20,
              }}
            >
              {dict.did_you_know}
            </Text>
            <Text
              style={{
                fontSize: 16,
                color: colors[theme].text,
              }}
            >
              {g.answerComplementMessage}
            </Text>
          </View>
        )}
    </View>
  );
}
